export interface BoxDimensions {
  readonly length: number;
  readonly width: number;
  readonly height: number;
}

const MIN_INCHES = 0.25;
const MAX_INCHES = 48;

/** Number, optional spaces, optional inch mark or in/inch/inches (any case). */
const DIM_TOKEN = String.raw`(\d+(?:\.\d+)?)\s*(?:"|''|[iI][nN](?:[cC][hH](?:[eE][sS])?)?)?`;
const SEP = String.raw`\s*[xX×]\s*`;
const DIM_PATTERN_SOURCE = `${DIM_TOKEN}${SEP}${DIM_TOKEN}${SEP}${DIM_TOKEN}`;

function isPlausibleInch(value: number): boolean {
  return Number.isFinite(value) && value >= MIN_INCHES && value <= MAX_INCHES;
}

function findFirstPlausible(text: string): BoxDimensions | null {
  const pattern = new RegExp(DIM_PATTERN_SOURCE, 'g');
  let match = pattern.exec(text);
  while (match) {
    const length = Number(match[1]);
    const width = Number(match[2]);
    const height = Number(match[3]);
    if (isPlausibleInch(length) && isPlausibleInch(width) && isPlausibleInch(height)) {
      return { length, width, height };
    }
    match = pattern.exec(text);
  }
  return null;
}

/**
 * Find an L × W × H substring in noisy OCR text from a box bottom.
 * The full string does not need to be the size — extra stamp text is ignored.
 */
export function extractBoxDimensionsFromOcr(ocrText: string): BoxDimensions | null {
  if (!ocrText.trim()) {
    return null;
  }
  const spaced = findFirstPlausible(ocrText);
  if (spaced) {
    return spaced;
  }
  return findFirstPlausible(ocrText.replace(/\s+/g, ''));
}
